import reviewReport from './review_report'

const ReviewServer = {
  reviewReport : reviewReport,
};

export default ReviewServer;
